import React from "react";
import Badge from "react-bootstrap/Badge";
import dayjs from "dayjs";

const ProjectHeaderTopBar = ({
  projectType = "",
  title = "",
  projectStartDate = "",
  projectEndDate = "",
  status = "",
  isProjectDetailsLoading = true,
  rightComponent = null,
  needProjectStatus = true,
}) => {
  const projectStart = dayjs(projectStartDate);
  const today = dayjs();

  const statusText =
    status == 1
      ? projectStart.isAfter(today)
        ? "Upcoming"
        : "Ongoing"
      : "Closed";

  const showProjectEndDate = !["Sponsored Content"].includes(projectType);

  return (
    <div className="header-title mb-md-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center align-items-start mb-3 flex-wrap gap-3">
      {/* LEFT */}
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center  gap-2 flex-wrap">
        <h4 className="fw-semibold mb-0 mb-md-0 events-title">{title}</h4>
        <div className="d-flex align-items-center flex-wrap gap-2">
          <Badge pill bg="primary" className="px-2 fs-7 rounded-pill">
            {projectType}
          </Badge>
          <Badge
            pill
            bg="secondary text-success"
            className="fs-7 bg-opacity-10 px-2"
          >
            {!isProjectDetailsLoading &&
              `Start Date: ${dayjs(projectStartDate).format("DD-MM-YYYY")}${
                showProjectEndDate
                  ? ` - End Date: ${dayjs(projectEndDate).format("DD-MM-YYYY")}`
                  : ""
              }`}
          </Badge>
        </div>
      </div>

      {/* RIGHT */}
      {rightComponent ? (
        <>{rightComponent}</>
      ) : needProjectStatus ? (
        <Badge
          pill
          bg={
            !isProjectDetailsLoading
              ? statusText === "Closed"
                ? "soft-danger"
                : statusText === "Upcoming"
                ? "soft-success"
                : "soft-primary"
              : "soft-secondary"
          }
          className="fs-7 text-dark fw-semibold rounded-pill"
        >
          Project Status :{" "}
          <span
            className={`${
              !isProjectDetailsLoading
                ? statusText === "Closed"
                  ? "text-danger"
                  : statusText === "Upcoming"
                  ? "text-success"
                  : "text-primary"
                : "text-secondary"
            }`}
          >
            {!isProjectDetailsLoading ? statusText : "Loading..."}
          </span>
        </Badge>
      ) : null}
    </div>
  );
};

export default ProjectHeaderTopBar;
